module.exports = __webpack_public_path__ + "img/ejoyExtension.ae8ac8c2.svg";